/**
 * Created by JasonChou on 16/5/7.
 */export const data = {
    '110000': {
        '0': '北京市',
        '110000': {
            '0': '北京市',
        }
    },
    '120000': {
        '0': '天津市',
        '120000': {
            '0': '天津市',
        }
    },
    '130000': {
        '0': '河北省',
        '130100': {
            '0': '石家庄市',
        },
        '130200': {
            '0': '唐山市',
        },
        '130300': {
            '0': '秦皇岛市',
        },
        '130400': {
            '0': '邯郸市',
        },
        '130500': {
            '0': '邢台市',
        },
        '130600': {
            '0': '保定市',
        },
        '130700': {
            '0': '张家口市',
        },
        '130800': {
            '0': '承德市',
        },
        '130900': {
            '0': '沧州市',
        },
        '131000': {
            '0': '廊坊市',
        },
        '131100': {
            '0': '衡水市',
        }
    },
    '140000': {
        '0': '山西省',
        '140100': {
            '0': '太原市',
        },
        '140200': {
            '0': '大同市',
        },
        '140300': {
            '0': '阳泉市',
        },
        '140400': {
            '0': '长治市',
        },
        '140500': {
            '0': '晋城市',
        },
        '140600': {
            '0': '朔州市',
        },
        '140700': {
            '0': '晋中市',
        },
        '140800': {
            '0': '运城市',
        },
        '140900': {
            '0': '忻州市',
        },
        '141000': {
            '0': '临汾市',
        },
        '141100': {
            '0': '吕梁市',
        }
    },
    '150000': {
        '0': '内蒙古自治区',
        '150100': {
            '0': '呼和浩特市',
        },
        '150200': {
            '0': '包头市',
        },
        '150300': {
            '0': '乌海市',
        },
        '150400': {
            '0': '赤峰市',
        },
        '150500': {
            '0': '通辽市',
        },
        '150600': {
            '0': '鄂尔多斯市',
        },
        '150700': {
            '0': '呼伦贝尔市',
        },
        '150800': {
            '0': '巴彦淖尔市',
        },
        '150900': {
            '0': '乌兰察布市',
        },
        '152200': {
            '0': '兴安盟',
        },
        '152500': {
            '0': '锡林郭勒盟',
        },
        '152900': {
            '0': '阿拉善盟',
        }
    },
    '210000': {
        '0': '辽宁省',
        '210100': {
            '0': '沈阳市',
        },
        '210200': {
            '0': '大连市',
        },
        '210300': {
            '0': '鞍山市',
        },
        '210400': {
            '0': '抚顺市',
        },
        '210500': {
            '0': '本溪市',
        },
        '210600': {
            '0': '丹东市',
        },
        '210700': {
            '0': '锦州市',
        },
        '210800': {
            '0': '营口市',
        },
        '210900': {
            '0': '阜新市',
        },
        '211000': {
            '0': '辽阳市',
        },
        '211100': {
            '0': '盘锦市',
        },
        '211200': {
            '0': '铁岭市',
        },
        '211300': {
            '0': '朝阳市',
        },
        '211400': {
            '0': '葫芦岛市',
        }
    },
    '220000': {
        '0': '吉林省',
        '220100': {
            '0': '长春市',
        },
        '220200': {
            '0': '吉林市',
        },
        '220300': {
            '0': '四平市',
        },
        '220400': {
            '0': '辽源市',
        },
        '220500': {
            '0': '通化市',
        },
        '220600': {
            '0': '白山市',
        },
        '220700': {
            '0': '松原市',
        },
        '220800': {
            '0': '白城市',
        },
        '222400': {
            '0': '延边朝鲜族自治州',
        }
    },
    '230000': {
        '0': '黑龙江省',
        '230100': {
            '0': '哈尔滨市',
        },
        '230200': {
            '0': '齐齐哈尔市',
        },
        '230300': {
            '0': '鸡西市',
        },
        '230400': {
            '0': '鹤岗市',
        },
        '230500': {
            '0': '双鸭山市',
        },
        '230600': {
            '0': '大庆市',
        },
        '230700': {
            '0': '伊春市',
        },
        '230800': {
            '0': '佳木斯市',
        },
        '230900': {
            '0': '七台河市',
        },
        '231000': {
            '0': '牡丹江市',
        },
        '231100': {
            '0': '黑河市',
        },
        '231200': {
            '0': '绥化市',
        },
        '232700': {
            '0': '大兴安岭地区',
        }
    },
    '310000': {
        '0': '上海市',
        '310000': {
            '0': '上海市',
        }
    },
    '320000': {
        '0': '江苏省',
        '320100': {
            '0': '南京市',
        },
        '320200': {
            '0': '无锡市',
        },
        '320300': {
            '0': '徐州市',
        },
        '320400': {
            '0': '常州市',
        },
        '320500': {
            '0': '苏州市',
        },
        '320600': {
            '0': '南通市',
        },
        '320700': {
            '0': '连云港市',
        },
        '320800': {
            '0': '淮安市',
        },
        '320900': {
            '0': '盐城市',
        },
        '321000': {
            '0': '扬州市',
        },
        '321100': {
            '0': '镇江市',
        },
        '321200': {
            '0': '泰州市',
        },
        '321300': {
            '0': '宿迁市',
        }
    },
    '330000': {
        '0': '浙江省',
        '330100': {
            '0': '杭州市',
        },
        '330200': {
            '0': '宁波市',
        },
        '330300': {
            '0': '温州市',
        },
        '330400': {
            '0': '嘉兴市',
        },
        '330500': {
            '0': '湖州市',
        },
        '330600': {
            '0': '绍兴市',
        },
        '330700': {
            '0': '金华市',
        },
        '330800': {
            '0': '衢州市',
        },
        '330900': {
            '0': '舟山市',
        },
        '331000': {
            '0': '台州市',
        },
        '331100': {
            '0': '丽水市',
        }
    },
    '340000': {
        '0': '安徽省',
        '340100': {
            '0': '合肥市',
        },
        '340200': {
            '0': '芜湖市',
        },
        '340300': {
            '0': '蚌埠市',
        },
        '340400': {
            '0': '淮南市',
        },
        '340500': {
            '0': '马鞍山市',
        },
        '340600': {
            '0': '淮北市',
        },
        '340700': {
            '0': '铜陵市',
        },
        '340800': {
            '0': '安庆市',
        },
        '341000': {
            '0': '黄山市',
        },
        '341100': {
            '0': '滁州市',
        },
        '341200': {
            '0': '阜阳市',
        },
        '341300': {
            '0': '宿州市',
        },
        '341500': {
            '0': '六安市',
        },
        '341600': {
            '0': '亳州市',
        },
        '341700': {
            '0': '池州市',
        },
        '341800': {
            '0': '宣城市',
        }
    },
    '350000': {
        '0': '福建省',
        '350100': {
            '0': '福州市',
        },
        '350200': {
            '0': '厦门市',
        },
        '350300': {
            '0': '莆田市',
        },
        '350400': {
            '0': '三明市',
        },
        '350500': {
            '0': '泉州市',
        },
        '350600': {
            '0': '漳州市',
        },
        '350700': {
            '0': '南平市',
        },
        '350800': {
            '0': '龙岩市',
        },
        '350900': {
            '0': '宁德市',
        }
    },
    '360000': {
        '0': '江西省',
        '360100': {
            '0': '南昌市',
        },
        '360200': {
            '0': '景德镇市',
        },
        '360300': {
            '0': '萍乡市',
        },
        '360400': {
            '0': '九江市',
        },
        '360500': {'0': '新余市',},
        '360600': {'0': '鹰潭市',},
        '360700': {
            '0': '赣州市',
        },
        '360800': {
            '0': '吉安市',

        },
        '360900': {
            '0': '宜春市',
        },
        '361000': {
            '0': '抚州市',
        },
        '361100': {
            '0': '上饶市',
        }
    },
    '370000': {
        '0': '山东省',
        '370100': {
            '0': '济南市',
        },
        '370200': {
            '0': '青岛市',
        },
        '370300': {
            '0': '淄博市',
        },
        '370400': {
            '0': '枣庄市',
        },
        '370500': {
            '0': '东营市',
        },
        '370600': {
            '0': '烟台市',
        },
        '370700': {
            '0': '潍坊市',
        },
        '370800': {
            '0': '济宁市',
        },
        '370900': {
            '0': '泰安市',
        },
        '371000': {
            '0': '威海市',
        },
        '371100': {
            '0': '日照市',
        },
        '371200': {'0': '莱芜市',},
        '371300': {
            '0': '临沂市',
        },
        '371400': {
            '0': '德州市',
        },
        '371500': {
            '0': '聊城市',
        },
        '371600': {
            '0': '滨州市',
        },
        '371700': {
            '0': '菏泽市',
        }
    },
    '410000': {
        '0': '河南省',
        '410100': {
            '0': '郑州市',
        },
        '410200': {
            '0': '开封市',
        },
        '410300': {
            '0': '洛阳市',
        },
        '410400': {
            '0': '平顶山市',
        },
        '410500': {
            '0': '安阳市',
        },
        '410600': {
            '0': '鹤壁市',
        },
        '410700': {
            '0': '新乡市',
        },
        '410800': {
            '0': '焦作市',
        },
        '410900': {
            '0': '濮阳市',
        },
        '411000': {
            '0': '许昌市',
        },
        '411100': {
            '0': '漯河市',
        },
        '411200': {
            '0': '三门峡市',
        },
        '411300': {
            '0': '南阳市',
        },
        '411400': {
            '0': '商丘市',
        },
        '411500': {
            '0': '信阳市',
        },
        '411600': {
            '0': '周口市',
        },
        '411700': {
            '0': '驻马店市',
        },
        '419000': {'0': '省直辖',}
    },
    '420000': {
        '0': '湖北省',
        '420100': {
            '0': '武汉市',
        },
        '420200': {
            '0': '黄石市',
        },
        '420300': {
            '0': '十堰市',
        },
        '420500': {
            '0': '宜昌市',
        },
        '420600': {
            '0': '襄阳市',
        },
        '420700': {'0': '鄂州市',},
        '420800': {
            '0': '荆门市',
        },
        '420900': {
            '0': '孝感市',
        },
        '421000': {
            '0': '荆州市',
        },
        '421100': {
            '0': '黄冈市',
        },
        '421200': {
            '0': '咸宁市',
        },
        '421300': {'0': '随州市',},
        '422800': {
            '0': '恩施土家族苗族自治州',
        },
        '429000': {
            '0': '省直辖',
        }
    },
    '430000': {
        '0': '湖南省',
        '430100': {
            '0': '长沙市',
        },
        '430200': {
            '0': '株洲市',
        },
        '430300': {
            '0': '湘潭市',
        },
        '430400': {
            '0': '衡阳市',
        },
        '430500': {
            '0': '邵阳市',
        },
        '430600': {
            '0': '岳阳市',
        },
        '430700': {
            '0': '常德市',
        },
        '430800': {
            '0': '张家界市',
        },
        '430900': {
            '0': '益阳市',
        },
        '431000': {
            '0': '郴州市',
        },
        '431100': {
            '0': '永州市',
        },
        '431200': {
            '0': '怀化市',
        },
        '431300': {
            '0': '娄底市',
        },
        '433100': {
            '0': '湘西土家族苗族自治州',
        }
    },
    '440000': {
        '0': '广东省',
        '440100': {
            '0': '广州市',
        },
        '440200': {
            '0': '韶关市',
        },
        '440300': {
            '0': '深圳市',
        },
        '440400': {'0': '珠海市',},
        '440500': {
            '0': '汕头市',
        },
        '440600': {
            '0': '佛山市',
        },
        '440700': {
            '0': '江门市',
        },
        '440800': {
            '0': '湛江市',
        },
        '440900': {
            '0': '茂名市',
        },
        '441200': {
            '0': '肇庆市',
        },
        '441300': {
            '0': '惠州市',
        },
        '441400': {
            '0': '梅州市',
        },
        '441500': {
            '0': '汕尾市',
        },
        '441600': {
            '0': '河源市',
        },
        '441700': {
            '0': '阳江市',
        },
        '441800': {
            '0': '清远市',
        },
        '441900': {'0': '东莞市',},
        '442000': {'0': '中山市',},
        '445100': {'0': '潮州市',},
        '445200': {
            '0': '揭阳市',
        },
        '445300': {
            '0': '云浮市',
        }
    },
    '450000': {
        '0': '广西壮族自治区',
        '450100': {
            '0': '南宁市',
        },
        '450200': {
            '0': '柳州市',
        },
        '450300': {
            '0': '桂林市',
        },
        '450400': {
            '0': '梧州市',
        },
        '450500': {
            '0': '北海市',
        },
        '450600': {
            '0': '防城港市',
        },
        '450700': {
            '0': '钦州市',
        },
        '450800': {
            '0': '贵港市',
        },
        '450900': {
            '0': '玉林市',
        },
        '451000': {
            '0': '百色市',
        },
        '451100': {
            '0': '贺州市',
        },
        '451200': {
            '0': '河池市',
        },
        '451300': {
            '0': '来宾市',
        },
        '451400': {
            '0': '崇左市',
        }
    },
    '460000': {
        '0': '海南省',
        '460100': {
            '0': '海口市',
        },
        '460200': {'0': '三亚市',},
        '460300': {
            '0': '三沙市',
        },
        '469000': {
            '0': '省直辖',
        }
    },
    '500000': {
        '0': '重庆市',
        '500000': {
            '0': '重庆市'
        }
    },
    '510000': {
        '0': '四川省',
        '510100': {
            '0': '成都市',
        },
        '510300': {
            '0': '自贡市',
        },
        '510400': {
            '0': '攀枝花市',
        },
        '510500': {
            '0': '泸州市',
        },
        '510600': {
            '0': '德阳市',
        },
        '510700': {
            '0': '绵阳市',
        },
        '510800': {
            '0': '广元市',
        },
        '510900': {
            '0': '遂宁市',
        },
        '511000': {
            '0': '内江市',
        },
        '511100': {
            '0': '乐山市',
        },
        '511300': {
            '0': '南充市',
        },
        '511400': {
            '0': '眉山市',
        },
        '511500': {
            '0': '宜宾市',
        },
        '511600': {
            '0': '广安市',
        },
        '511700': {
            '0': '达州市',
        },
        '511800': {
            '0': '雅安市',
        },
        '511900': {
            '0': '巴中市',
        },
        '512000': {
            '0': '资阳市',
        },
        '513200': {
            '0': '阿坝藏族羌族自治州',
        },
        '513300': {
            '0': '甘孜藏族自治州',
        },
        '513400': {
            '0': '凉山彝族自治州',
        }
    },
    '520000': {
        '0': '贵州省',
        '520100': {
            '0': '贵阳市',
        },
        '520200': {
            '0': '六盘水市',
        },
        '520300': {
            '0': '遵义市', '520330': '习水县',
        },
        '520400': {
            '0': '安顺市',
        },
        '520500': {
            '0': '毕节市',
        },
        '520600': {
            '0': '铜仁市',
        },
        '522300': {
            '0': '黔西南布依族苗族自治州',
        },
        '522600': {
            '0': '黔东南苗族侗族自治州',
        },
        '522700': {
            '0': '黔南布依族苗族自治州',
        }
    },
    '530000': {
        '0': '云南省',
        '530100': {
            '0': '昆明市',
        },
        '530300': {
            '0': '曲靖市',
        },
        '530400': {
            '0': '玉溪市',
        },
        '530500': {
            '0': '保山市',
        },
        '530600': {
            '0': '昭通市',
        },
        '530700': {
            '0': '丽江市',
        },
        '530800': {
            '0': '普洱市',
        },
        '530900': {
            '0': '临沧市',
        },
        '532300': {
            '0': '楚雄彝族自治州',
        },
        '532500': {
            '0': '红河哈尼族彝族自治州',
        },
        '532600': {
            '0': '文山壮族苗族自治州',
        },
        '532800': {
            '0': '西双版纳傣族自治州',
        },
        '532900': {
            '0': '大理白族自治州',
        },
        '533100': {
            '0': '德宏傣族景颇族自治州',
        },
        '533300': {
            '0': '怒江傈僳族自治州',
        },
        '533400': {
            '0': '迪庆藏族自治州',
        }
    },
    '540000': {
        '0': '西藏自治区',
        '540100': {
            '0': '拉萨市',
        },
        '542100': {
            '0': '昌都地区',
        },
        '542200': {
            '0': '山南地区',
        },
        '542300': {
            '0': '日喀则地区',
        },
        '542400': {
            '0': '那曲地区',
        },
        '542500': {
            '0': '阿里地区',
        },
        '542600': {
            '0': '林芝地区',
        }
    },
    '610000': {
        '0': '陕西省',
        '610100': {
            '0': '西安市',
        },
        '610200': {
            '0': '铜川市',
        },
        '610300': {
            '0': '宝鸡市',
        },
        '610400': {
            '0': '咸阳市'
        },
        '610500': {
            '0': '渭南市',
        },
        '610600': {
            '0': '延安市',
        },
        '610700': {
            '0': '汉中市',
        },
        '610800': {
            '0': '榆林市'

        },
        '610900': {
            '0': '安康市',
        },
        '611000': {
            '0': '商洛市',
        }
    },
    '620000': {
        '0': '甘肃省',
        '620100': {
            '0': '兰州市',
        },
        '620200': {'0': '嘉峪关市',},
        '620300': {'0': '金昌市',},
        '620400': {
            '0': '白银市',
        },
        '620500': {
            '0': '天水市',
        },
        '620600': {
            '0': '武威市',
        },
        '620700': {
            '0': '张掖市',
        },
        '620800': {
            '0': '平凉市',
        },
        '620900': {
            '0': '酒泉市',
        },
        '621000': {
            '0': '庆阳市',
        },
        '621100': {
            '0': '定西市',
        },
        '621200': {
            '0': '陇南市',
        },
        '622900': {
            '0': '临夏回族自治州',
        },
        '623000': {
            '0': '甘南藏族自治州',
        }
    },
    '630000': {
        '0': '青海省',
        '630100': {
            '0': '西宁市',
        },
        '632100': {
            '0': '海东地区',
        },
        '632200': {
            '0': '海北藏族自治州',
        },
        '632300': {
            '0': '黄南藏族自治州',
        },
        '632500': {
            '0': '海南藏族自治州',
        },
        '632600': {
            '0': '果洛藏族自治州',
        },
        '632700': {
            '0': '玉树藏族自治州',
        },
        '632800': {
            '0': '海西蒙古族藏族自治州',
        }
    },
    '640000': {
        '0': '宁夏回族自治区',
        '640100': {
            '0': '银川市',
        },
        '640200': {
            '0': '石嘴山市',
        },
        '640300': {
            '0': '吴忠市',
        },
        '640400': {
            '0': '固原市',
        },
        '640500': {'0': '中卫市',}
    },
    '650000': {
        '0': '新疆维吾尔自治区',
        '650100': {
            '0': '乌鲁木齐市',
        },
        '650200': {
            '0': '克拉玛依市',
        },
        '652100': {
            '0': '吐鲁番地区',
        },
        '652200': {
            '0': '哈密地区',
        },
        '652300': {
            '0': '昌吉回族自治州',
        },
        '652700': {
            '0': '博尔塔拉蒙古自治州',
        },
        '652800': {
            '0': '巴音郭楞蒙古自治州',
        },
        '652900': {
            '0': '阿克苏地区',
        },
        '653000': {
            '0': '克孜勒苏柯尔克孜自治州',
        },
        '653100': {
            '0': '喀什地区',

        },
        '653200': {
            '0': '和田地区',
        },
        '654000': {
            '0': '伊犁哈萨克自治州',
        },
        '654200': {
            '0': '塔城地区',
        },
        '654300': {
            '0': '阿勒泰地区',
        },
        '659000': {
            '0': '自治区直辖',
        }
    },
    '710000': {
        '0': '台湾省',
        '710100': {
            '0': '台北市',
        },
        '710200': {
            '0': '高雄市',

        },
        '710300': {
            '0': '基隆市',
        },
        '710400': {
            '0': '台中市',
        },
        '710500': {
            '0': '台南市',
        },
        '710600': {'0': '新竹市',},
        '710700': {'0': '嘉义市',},
        '719000': {
            '0': '省直辖',
        }
    },
    '810000': {
        '0': '香港特别行政区',
        '810100': {
            '0': '香港岛',
        },
        '810200': {
            '0': '九龙',
        },
        '810300': {
            '0': '新界',
        }
    },
    '820000': {
        '0': '澳门特别行政区',
        '820100': {
            '0': '澳门半岛',
        },
        '820200': {'0': '澳门离岛',},
        '820300': {'0': '无堂区划分区域',}
    }
};
export const getSelection = function (code, turn) {
    let i, j, k, proNum, cityNum, array = [];
    if (!code) {
        for (i in data) {
            array.push({
                code: i,
                name: data[i][0]
            })
        }
        return array;
    }
    else if (turn === 1) {
        proNum = Math.floor(code / 10000) * 10000;
        if (data[proNum]) {
            for (i in data[proNum]) {
                if (i !== '0') {
                    array.push({
                        code: i,
                        name: data[proNum][i][0]
                    })
                }
            }
            return array;
        }
        else {
            return null;
        }
    }
    else if (turn === 2) {
        proNum = Math.floor(code / 10000) * 10000;
        cityNum = Math.floor(code / 100) * 100;
        if (data[proNum][cityNum]) {
            for (i in data[proNum][cityNum]) {
                if (i !== '0') {
                    array.push({
                        code: i,
                        name: data[proNum][cityNum][i]
                    })
                }
            }
            return array;
        }
        else {
            return null;
        }
    }
};


//所在市信息
export const getCityInfo = (cityCode) => {
    try {
        const proCode = Math.floor(cityCode / 10000) * 10000;
        return data[proCode][cityCode][0]
    } catch (e) {
        return '未知'
    }
};

export const getProvinces = () => {
    const provinces = [];
    for (let pcode in data) {
        let p = data[pcode];

        provinces.push({
            code: pcode,
            name: p[0]
        })

    }

    return provinces;
};

export const getCities = () => {
    const cities = [];
    for (let pcode in data) {
        let p = data[pcode];
        for (let ccode in p) {
            if (ccode == 0)
                continue;
            let c = p[ccode];
            cities.push({
                code: ccode,
                name: c[0]
            })
        }
    }

    return cities;
};

export const getCitiesByProvince = (pcode) => {
    const cities = [];
    let p = data[pcode];
    for (let ccode in p) {
        if (ccode == 0)
            continue;
        let c = p[ccode];
        cities.push({
            code: ccode,
            name: c[0]
        })
    }

    return cities;
};


// WEBPACK FOOTER //
// ./src/utils/cityUtils.js